export default __webpack_public_path__ + "static/media/insights-empty-statement.ca96fa38.svg";